import axios from "../../../../api/axios";

import { EntityType } from "../../../../types";
import { Entity, EntityLevel } from "../../../../types/types";

interface UpdateEntityProfilePayload {
  about: string;
  mediaUrl: string;
  // name: string;
  name_ar: string;
  name_en: string;
  level: EntityLevel;
  type: EntityType;
  countryId: number;
  foundedYear: number;
  listEntry: number[];
}

export const updateEntityProfile = async (entityId: number, payload: UpdateEntityProfilePayload) => {
  try {
    const response = await axios.put<{ footballEntity: Entity }>(`/football-entities/${entityId}`, payload);
    return response.data.footballEntity;
  } catch (error) {
    throw new Error("Failed to update entity profile");
  }
};
